<template>
  <header>
    <div :class="isDarkMode ? 'bg-cblack text-white opacity-95' : 'bg-white'">
      <nav class="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8" aria-label="Top">
        <div class="flex items-center justify-between py-2 sm:py-2">
          <div class="justify-start flex-1">
            <NuxtLink to="/">
              <span class="sr-only">Colonia Technologies</span>
              <img
                class="hidden w-auto h-10 md:block"
                :src="
                  isDarkMode
                    ? '/colonia_logo_text_white.svg'
                    : '/colonia_logo_text.svg'
                "
                alt="Colonia Technologies"
              />
              <img
                class="w-auto h-10 md:hidden"
                :src="
                  isDarkMode
                    ? '/colonia_logo_text_white.svg'
                    : '/colonia_logo_icon.svg'
                "
                alt="Colonia Technologies"
              />
            </NuxtLink>
          </div>
          <slot />
        </div>
      </nav>
    </div>
  </header>
</template>

<script setup lang="ts">
defineProps({
  isDarkMode: {
    type: Boolean,
    default: false,
  },
  bannerMessage: {
    type: String,
    default: '',
  },
  bannerLink: {
    type: String,
    default: '',
  },
})
</script>
